import SEO from '../components/SEO'
import './Legal.css'

export default function PrivacyPolicy() {
  return (
    <>
      <SEO title="Privacy Policy" description="NexCore Solutions Privacy Policy — how we collect, use, and protect your personal data in compliance with DPDP Act 2023 and GDPR." path="/privacy" />
      <section className="page-hero"><div className="container"><p className="section-label">Legal</p><h1 className="section-title">Privacy Policy</h1><p className="section-subtitle">Last updated: 1 June 2025</p></div></section>
      <section className="legal-section"><div className="container"><div className="prose">
        <p>NexCore Solutions Private Limited ("NexCore", "we", "us") is committed to protecting the privacy of individuals who visit our website and use our products. This Privacy Policy explains what personal data we collect, how we use it, and your rights in relation to it. This policy is compliant with the Digital Personal Data Protection Act 2023 (India) and, where applicable, the General Data Protection Regulation (GDPR).</p>

        <h2>1. Information We Collect</h2>
        <h3>Information you provide directly</h3>
        <ul>
          <li>Contact details (name, email address, phone number, designation)</li>
          <li>Company information (company name, industry, size)</li>
          <li>Account credentials (email and encrypted password)</li>
          <li>Communications you send us via contact forms, email, or support tickets</li>
        </ul>
        <h3>Information collected automatically</h3>
        <ul>
          <li>Log data (IP address, browser type, pages visited, timestamps)</li>
          <li>Device information (operating system, screen resolution)</li>
          <li>Usage analytics (feature usage patterns, session duration)</li>
          <li>Cookies and similar tracking technologies (see our Cookie Policy)</li>
        </ul>
        <h3>Customer Data (data processed on your behalf)</h3>
        <p>When you use our products, you may input data relating to your employees, customers, or business operations. NexCore processes this data only as a data processor on your instructions. You remain the data controller and are responsible for the lawfulness of this data.</p>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To provide, maintain, and improve our products and services</li>
          <li>To communicate with you about your account, updates, and support</li>
          <li>To send you relevant product news and marketing communications (with your consent)</li>
          <li>To process payments and prevent fraud</li>
          <li>To comply with our legal obligations under applicable Indian law</li>
          <li>To conduct product analytics and improve user experience</li>
        </ul>

        <h2>3. Legal Basis for Processing</h2>
        <p>We process your personal data on the following legal bases: (a) performance of a contract — to provide the services you have subscribed to; (b) legitimate interests — to improve our products, prevent fraud, and conduct business analytics; (c) legal obligation — to comply with applicable laws; and (d) consent — for marketing communications and non-essential cookies, where we obtain your explicit consent.</p>

        <h2>4. Data Sharing and Disclosure</h2>
        <p>We do not sell your personal data. We may share data with:</p>
        <ul>
          <li>Sub-processors (cloud infrastructure, email delivery, payment gateway providers) who are contractually bound to protect your data</li>
          <li>Professional advisors (lawyers, auditors) under confidentiality obligations</li>
          <li>Law enforcement or regulatory authorities when required by applicable law</li>
          <li>Successor entities in the event of a merger, acquisition, or sale of assets, with appropriate notice to you</li>
        </ul>

        <h2>5. Data Retention</h2>
        <p>We retain personal data for as long as your account is active or as needed to provide services. After account termination, we retain data for a further 90 days to allow data export. Thereafter, data is securely deleted or anonymised, except where retention is required by law (e.g., GST records for 7 years).</p>

        <h2>6. Data Security</h2>
        <p>We implement industry-standard security measures including TLS 1.3 encryption in transit, AES-256 encryption at rest, role-based access controls, multi-factor authentication, regular penetration testing, and 24/7 security monitoring. Despite these measures, no system is completely secure; we encourage you to use strong passwords and enable MFA.</p>

        <h2>7. Your Rights</h2>
        <p>Subject to applicable law, you have the right to:</p>
        <ul>
          <li>Access the personal data we hold about you</li>
          <li>Correct inaccurate or incomplete data</li>
          <li>Request deletion of your personal data ("right to be forgotten")</li>
          <li>Restrict or object to processing</li>
          <li>Data portability (receive your data in a machine-readable format)</li>
          <li>Withdraw consent at any time (without affecting prior processing)</li>
        </ul>
        <p>To exercise these rights, email us at <a href="mailto:privacy@nexcoresolutions.com">privacy@nexcoresolutions.com</a>. We will respond within 30 days.</p>

        <h2>8. International Transfers</h2>
        <p>Your data is stored on servers located in India. If we transfer data outside India (e.g., to international sub-processors), we ensure appropriate safeguards are in place, including standard contractual clauses approved by relevant authorities.</p>

        <h2>9. Children's Privacy</h2>
        <p>Our services are not directed at individuals under the age of 18. We do not knowingly collect personal data from minors. If we become aware that we have collected data from a minor, we will delete it promptly.</p>

        <h2>10. Changes to This Policy</h2>
        <p>We may update this Privacy Policy periodically. Material changes will be communicated by email or prominent notice on our website at least 30 days before taking effect.</p>

        <h2>11. Contact Our Data Protection Team</h2>
        <p>For privacy queries, data requests, or to raise a concern: <a href="mailto:privacy@nexcoresolutions.com">privacy@nexcoresolutions.com</a><br />NexCore Solutions Pvt. Ltd., Attn: Data Protection Officer, 4th Floor, Cyber Tower, Tidel Park, Chennai – 600 113.</p>
      </div></div></section>
    </>
  )
}
